import Vue from 'vue';
import VueSkipTo from 'vue-skip-to';
import Vuelidate from 'vuelidate';
import VueGtm from '@gtm-support/vue2-gtm';
import Ads from 'vue-google-adsense';
import store from '@/store';
import App from './App.vue';
import router from './routes';
import vuetify from './plugins/vuetify';
import './plugins/directives';
import filters from './plugins/filters';
import loadScript from './plugins/loadscript';

store.dispatch('setPublicPages', [
  'login',
  'redefinir-senha',
  'nao-sei-minha-senha',
  'confirmacao-email-enviado',
  'rastrear-envio',
]);

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueSkipTo);
Vue.use(require('vue-script2'));

Vue.use(Ads.Adsense);

if (process.env.VUE_APP_GOOGLE_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_GTM_ID,
    vueRouter: router,
  });
}

Object.entries(filters)
  .forEach(([filterName, filterFunction]) => {
    Vue.filter(filterName, filterFunction);
  });

Vue.mixin({
  computed: {
    desktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  loadScript,
  render: h => h(App),
}).$mount('#app');
